import { type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {}

export const CardHeader = ({ className, ...props }: CardHeaderProps) => {
  return <div className={twMerge('flex items-start gap-2 mb-3', className)} {...props} />
}

CardHeader.displayName = 'CardHeader'
